// extracted by mini-css-extract-plugin
export default {"card":"kioskFooter_card__vG1hw"};